import { render } from "./AppNavSettings.vue?vue&type=template&id=937e37b4&scoped=true"
import script from "./AppNavSettings.vue?vue&type=script&lang=js"
export * from "./AppNavSettings.vue?vue&type=script&lang=js"

import "./AppNavSettings.vue?vue&type=style&index=0&id=937e37b4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937e37b4"]])

export default __exports__